import { render, staticRenderFns } from "./NetInterestIncomeSensitivity.vue?vue&type=template&id=50b5c958&scoped=true"
import script from "./NetInterestIncomeSensitivity.vue?vue&type=script&lang=js"
export * from "./NetInterestIncomeSensitivity.vue?vue&type=script&lang=js"
import style0 from "./NetInterestIncomeSensitivity.vue?vue&type=style&index=0&id=50b5c958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5c958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
